module.exports = __webpack_public_path__ + "img/NGR_Icon.e1124ecd.png";